import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getConsumptionSourceList as getConsumptionSourceListApi,
	getConsumptionSource as getConsumptionSourceApi,
	addNewConsumptionSource as addNewConsumptionSourceApi,
	updateConsumptionSource as updateConsumptionSourceApi,
	deleteConsumptionSource as deleteConsumptionSourceApi,
} from '../../helpers/establishment/backend_helper';

export const getConsumptionSourceList = createAsyncThunk('consumptionSource/getConsumptionSourceList', async () => {
	try {
		const response = getConsumptionSourceListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getConsumptionSource = createAsyncThunk('consumptionSource/getConsumptionSource', async periodicity_id => {
	try {
		const response = getConsumptionSourceApi(periodicity_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewConsumptionSource = createAsyncThunk('consumptionSource/addNewConsumptionSource', async periodicity => {
	try {
		const response = addNewConsumptionSourceApi(periodicity);
		toast.success('Fuente de Consumo agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar periodicity.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateConsumptionSource = createAsyncThunk('consumptionSource/updateConsumptionSource', async (periodicity) => {
		try {
			const response = updateConsumptionSourceApi(periodicity);
			toast.success('Fuente de Consumo actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar periodicity.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteConsumptionSource = createAsyncThunk('consumptionSource/deleteConsumptionSource', async periodicity => {
	try {
		const response = await deleteConsumptionSourceApi(periodicity);
		toast.success('Fuente de Consumo eliminado exitosamente.', { autoClose: 3000 });
		return { periodicity, ...response };
	} catch (error) {
		toast.error('Error al eliminar periodicity.', { autoClose: 3000 });
		throw new Error(error);
	}
});
